/**
 * SISTEMA DE NAVEGAÇÃO ENTRE PROJETOS
 * Controla redirecionamentos protegidos entre módulos
 */

import { FRONTEND_URLS } from '../../config/api';

class Navigation {
    
    // URLs dos projetos (ajustadas para funcionamento correto)
    static ROUTES = FRONTEND_URLS;

    /**
     * Redireciona para a página de login
     */
    static goToLogin() {
        console.log('🔄 Redirecionando para login...');
        window.location.href = this.ROUTES.LOGIN;
    }

    /**
     * Redireciona para o dashboard (após autenticação)
     */
    static goToDashboard() {
        console.log('🔄 Redirecionando para dashboard...');
        window.location.href = this.ROUTES.DASHBOARD;
    }

    /**
     * Redireciona para licitação (após autenticação)
     */
    static goToLicitacao() {
        if (!this.ROUTES.LICITACAO) {
            console.warn('⚠️ Módulo Licitações indisponível. Nenhum redirecionamento será feito.');
            alert('Módulo de Licitações ainda não está disponível nesta instalação.');
            return;
        }

        // Propagar sessão via querystring para outra origem (3002)
        import('../auth/auth.js').then(({ default: AuthSystem }) => {
            const user = AuthSystem.getCurrentUser();
            let target = this.ROUTES.LICITACAO;
            if (user) {
                try {
                    const encoded = btoa(JSON.stringify(user));
                    const joiner = target.includes('?') ? '&' : '?';
                    target = `${target}${joiner}login=${encoded}`;
                } catch (e) {
                    console.warn('Não foi possível serializar sessão para propagação:', e);
                }
            }
            console.log('🔄 Redirecionando para licitação...', target);
            window.location.href = target;
        });
    }

    /**
     * Navegação protegida - só redireciona se autenticado
     * @param {string} route - Rota de destino ('dashboard', 'licitacao')
     */
    static navigateProtected(route) {
        // Importa dinamicamente para evitar dependência circular
        import('../auth/auth.js').then(({ default: AuthSystem }) => {
            
            if (!AuthSystem.isAuthenticated()) {
                console.log('❌ Navegação negada - usuário não autenticado');
                this.goToLogin();
                return;
            }

            // Se autenticado, navega para a rota solicitada
            switch (route.toLowerCase()) {
                case 'dashboard':
                    this.goToDashboard();
                    break;
                case 'licitacao':
                    this.goToLicitacao();
                    break;
                default:
                    console.error('❌ Rota inválida:', route);
                    this.goToDashboard(); // Fallback para dashboard
            }
        });
    }

    /**
     * Logout e redirecionamento para login
     */
    static logout() {
        // Importa dinamicamente para evitar dependência circular
        import('../auth/auth.js').then(({ default: AuthSystem }) => {
            AuthSystem.logout();
            this.goToLogin();
        });
    }

    /**
     * Verifica e redireciona se necessário (para usar em cada página)
     * Esta é a função principal que cada projeto deve chamar
     */
    static checkAuthAndRedirect() {
        // Importa dinamicamente para evitar dependência circular
        import('../auth/auth.js').then(({ default: AuthSystem }) => {
            
            // Se não está na página de login E não está autenticado
            const isLoginPage = window.location.href.includes('LoginInicial');
            
            if (!isLoginPage && !AuthSystem.isAuthenticated()) {
                console.log('🔒 Acesso não autorizado - redirecionando...');
                this.goToLogin();
            }
            
            // Se está na página de login E já está autenticado
            if (isLoginPage && AuthSystem.isAuthenticated()) {
                console.log('✅ Usuário já logado - redirecionando para dashboard...');
                this.goToDashboard();
            }
        });
    }

    /**
     * Função helper para atualizar URLs se a estrutura mudar
     * @param {Object} newRoutes - Novas rotas para atualizar
     */
    static updateRoutes(newRoutes) {
        this.ROUTES = { ...this.ROUTES, ...newRoutes };
        console.log('✅ Rotas atualizadas:', this.ROUTES);
    }
}

export default Navigation;